import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useWalletAddress } from '../hooks/useWalletAddress';

import { showModalAction } from '@/shared/store/modals/actions';
import { ModalName } from '@/shared/store/modals/constants';
import { Button, ButtonVariant } from '@/shared/ui';

export const ConnectedWalletInfo = () => {
    const dispatch = useDispatch();
    const { shortAddressName } = useWalletAddress();

    const handleClick = useCallback(() => {
        dispatch(showModalAction({ modalName: ModalName.WALLET_INFO_MODAL }));
    }, [dispatch]);

    return (
        <Button
            variant={ButtonVariant.Tertiary}
            name='connected-wallet-info'
            className='flex items-center rounded border border-opaque h-[44px] shadow-none'
            onClick={handleClick}
        >
            <div className='text-primary text-md font-semibold'>{shortAddressName}</div>
        </Button>
    );
};
